export default __webpack_public_path__ + "110529f980feec5d6dd0f87123914c51.png";